// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loading: false,
  code: '',
  amount: '',
  // The scanned voucher (VoucherScanDto), or null before a lookup.
  voucher: null,
  message: null,
};

const redeemVoucherReducer = createReducer(initialState, {
  [types.REDEEM_START_LOADER](state) {
    return { ...state, loading: true };
  },
  [types.REDEEM_STOP_LOADER](state) {
    return { ...state, loading: false };
  },
  [types.REDEEM_CHANGE_CODE](state, action) {
    // Clear any looked-up voucher as soon as the code changes, so the balance
    // on screen can never belong to a different code than the one typed.
    return {
      ...state, code: action.payload, voucher: null, message: null,
    };
  },
  [types.REDEEM_CHANGE_AMOUNT](state, action) {
    return { ...state, amount: action.payload, message: null };
  },
  [types.REDEEM_SCAN_VOUCHER_SUCCESS](state, action) {
    return { ...state, voucher: action.payload };
  },
  [types.REDEEM_VOUCHER_SUCCESS](state, action) {
    const balanceLeft = parseFloat(action.payload.BalanceRemaining);

    return {
      ...state,
      amount: '',
      // Keep the voucher on screen with its new balance so the operator can
      // see what is left, and take a second amount off if needed.
      voucher: state.voucher
        ? {
          ...state.voucher,
          Balance: action.payload.BalanceRemaining,
          Status: action.payload.Status,
          // Spending the last of it has to close the amount box, the same way
          // it is absent when an already-spent voucher is scanned fresh.
          // RedeemVoucher's response has no IsRedeemable of its own - it
          // reports the balance - so it is derived here.
          //
          // Written as "not at or below zero" rather than "above zero" on
          // purpose: if the figure ever came back missing, parseFloat gives
          // NaN and both comparisons are false, so this leaves the box open
          // rather than hiding it on a number we did not actually get.
          IsRedeemable: state.voucher.IsRedeemable && !(balanceLeft <= 0),
        }
        : state.voucher,
    };
  },
  [types.REDEEM_SET_MESSAGE](state, action) {
    return { ...state, message: action.payload };
  },
  [types.REDEEM_RESET]() {
    return { ...initialState };
  },
});

export default redeemVoucherReducer;
